import { render, staticRenderFns } from "./Surveys.vue?vue&type=template&id=06241532&scoped=true&"
import script from "./Surveys.vue?vue&type=script&lang=ts&"
export * from "./Surveys.vue?vue&type=script&lang=ts&"
import style0 from "./Surveys.vue?vue&type=style&index=0&id=06241532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06241532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06241532')) {
      api.createRecord('06241532', component.options)
    } else {
      api.reload('06241532', component.options)
    }
    module.hot.accept("./Surveys.vue?vue&type=template&id=06241532&scoped=true&", function () {
      api.rerender('06241532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Surveys.vue"
export default component.exports